export default {
  // 教师禁用展示文案
  teacherDisableText: "Teacher's information is not found. Go find more of our outstanding teachers!",
  exceptionText: 'More excellent teachers are on the way. Please stay tuned.',
  teacher: 'our teacher',
  intro: {
    title: 'Expert Math Teachers from the Top US Universities',
    describe: 'Our exceptional math teachers are selected via a rigorous process with a passing rate of 2.0%. All our math teachers hold degrees from the top US universities, including Yale, Stanford, Columbia, University of Pennsylvania, and many more.',
  },
  detailTabs: [{ title: 'Profile', name: 'Profile' }, { title: 'Courses', name: 'Courses' }],
  achievement: 'Achievements',
  longTerm: 'Long Term Course',
  shortTerm: 'Short Term Course',
}
